var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7 2.5.34 1.358-.319.538A3.318 3.318 0 0 0 6.5 6.181V6.3a3.2 3.2 0 0 0 5.12 2.56l.747-.56 1.133.2c0 1-.5 2-.5 2-1 2-3.19 2.982-5.39 2.815l-.213-.016A5.441 5.441 0 0 1 5.36 3.014c.445-.2.817-.34 1.639-.514Zm-.694 1.158-.495.25A4.441 4.441 0 0 0 7.473 12.3l.214.017a4.71 4.71 0 0 0 4.447-2.36l.233-.408-.147.11A4.2 4.2 0 0 1 5.5 6.3v-.119c0-.823.235-1.629.678-2.323l.128-.2Z",
    fill: "currentColor"
  })));
};
export default SvgMoon;